import {
  GET_ORG_BILLABLE_EVENTS_TOTAL_REQUEST,
  GET_USER_BILLABLE_EVENTS_TOTAL_REQUEST,
} from 'js/constants/actionTypes';
import { getOrgAccountMetrics, getUserAccountMetrics } from 'js/reducers/metrics';
import has from 'lodash/has';
import { useSelector } from 'react-redux';
import { useCurrentUser } from 'new/hooks/adapters/useCurrentUser';
import { useIsLoading } from 'new/hooks/adapters/useIsLoading';

export function useAccountMetrics() {
  const currentUser = useCurrentUser();
  const userAccountMetrics = useSelector(getUserAccountMetrics);
  let orgAccountMetrics = useSelector(getOrgAccountMetrics);
  const isLoading = useIsLoading(
    GET_USER_BILLABLE_EVENTS_TOTAL_REQUEST,
    GET_ORG_BILLABLE_EVENTS_TOTAL_REQUEST,
  );
  orgAccountMetrics = currentUser.isOrgAdmin ? orgAccountMetrics : null;

  const userBillableEvents =
    userAccountMetrics && has(userAccountMetrics, 'accountMetrics.metrics')
      ? userAccountMetrics.accountMetrics.metrics
      : null;

  const orgBillableEvents =
    orgAccountMetrics && has(orgAccountMetrics, 'accountMetrics.metrics')
      ? orgAccountMetrics.accountMetrics.metrics
      : null;

  return {
    isLoading,
    orgData: orgBillableEvents,
    userData: userBillableEvents,
  };
}
